var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "399.000000pt",
    height: "364.000000pt",
    viewBox: "0 0 399.000000 364.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,364.000000) scale(0.100000,-0.100000)",
    fill: "rgba(255, 34, 5, 0.877)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1905 3131 c-16 -10 -258 -248 -536 -527 -406 -408 -509 -517 -519 -548 -17 -54 -8 -126 23 -179 49 -84 170 -121 264 -82 25 11 136 114 338 315 165 165 304 300 308 300 3 0 8 -390 9 -867 3 -867 3 -868 25 -908 42 -79 105 -115 198 -115 93 0 160 46 190 129 13 38 15 155 15 896 0 468 3 855 7 859 4 3 142 -128 307 -292 185 -184 316 -305 339 -316 72 -33 177 -17 236 37 59 55 80 181 42 255 -24 46 -1004 1024 -1048 1046 -46 23 -159 21 -198 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpError);
export default __webpack_public_path__ + "static/media/arrow-up-error.ccf35fac60a541417999e5fed22c28e6.svg";
export { ForwardRef as ReactComponent };